// Dashboard 6 — User Journey / Funnel. One Sent → Opened → Clicked → Session
// Started → Converted funnel per message category, sorted by volume. opened /
// clicked of 0 on an unmeasured channel means that stage is effectively N/A.

import React from "react";
import { Skeleton } from "../../../ui/skeleton";
import { Panel } from "../../../Components/admin/reporting/controls";
import { FunnelSteps } from "../../../Components/admin/reporting/primitives";
import { getEngagementFunnel } from "../../../Services/adminEngagement";
import {
  ErrorBox,
  EmptyState,
  WindowBadge,
  fmtInt,
  useEngagementData,
} from "./engagementShared";

const FunnelTab = ({ range }) => {
  const { data, loading, error } = useEngagementData(
    () => getEngagementFunnel(range),
    [range]
  );

  const funnels = data?.funnels || [];

  if (error) return <ErrorBox>{error}</ErrorBox>;

  return (
    <div className="space-y-5">
      <div className="flex flex-wrap items-center gap-3">
        <WindowBadge window={data?.window} timezone={data?.timezone} />
        <span className="text-xs text-muted-foreground">
          A 0 at Opened/Clicked on an unmeasured channel = that stage isn't tracked yet.
        </span>
      </div>

      {loading && !data ? (
        <div className="grid gap-4 lg:grid-cols-2">
          {Array.from({ length: 2 }).map((_, i) => (
            <Skeleton key={i} className="h-48 w-full" />
          ))}
        </div>
      ) : funnels.length === 0 ? (
        <Panel title="Funnels">
          <EmptyState>No funnel data in this window.</EmptyState>
        </Panel>
      ) : (
        <div className="grid gap-4 lg:grid-cols-2">
          {funnels.map((f) => (
            <Panel
              key={f.category}
              title={f.category}
              right={
                <span className="text-xs text-muted-foreground">
                  {fmtInt(f.sent)} sent
                </span>
              }
            >
              <FunnelSteps
                steps={[
                  { label: "Sent", count: f.sent || 0 },
                  { label: "Opened", count: f.opened || 0 },
                  { label: "Clicked", count: f.clicked || 0 },
                  { label: "Session Started", count: f.session_started || 0 },
                  { label: "Converted", count: f.converted || 0 },
                ]}
              />
            </Panel>
          ))}
        </div>
      )}
    </div>
  );
};

export default FunnelTab;
